import React from "react";
import { ClassificationIcon, Tooltip, VerifiedBy } from "@sscs/ui";
import { isMaliciousOrSuspicious } from "../../utils";
import DeletedFileIcon from "../assets/images/icons/deleted-file.svg";
import styles from "./fileBrowser.module.scss";
const FileIcon = ({ classification, deleted, verified, fontSize, }) => {
    if (isMaliciousOrSuspicious(classification))
        return React.createElement(ClassificationIcon, { classification: classification });
    if (deleted)
        return (React.createElement(Tooltip, { trigger: "graphic", title: "Deleted in a subsequent layer" },
            React.createElement("div", { className: styles["deleted-file-icon"] },
                React.createElement(DeletedFileIcon, { fontSize: "small" }))));
    return React.createElement(VerifiedBy, { verified: verified, fontSize: fontSize });
};
export default FileIcon;
//# sourceMappingURL=FileIcon.js.map